import axios from "axios";

export default axios.create({
  baseURL: "https://insights.vooster.io",
  headers: {
    "Content-type": "application/json",
  },
});
